import { optimizationDashboardsChartPerformancesService } from '@/services';


export const dashboardsChartPerformances = {
    namespaced: true,
    state: {
        all: [],
        loading: false
    },
    actions: {
        getByDateRange({ commit }, payload) {
            commit('getAllRequest');

            let dailyChartType = payload['dailyChartType'],
                fromDate = payload['fromDate'],
                toDate = payload['toDate'];

            optimizationDashboardsChartPerformancesService.getByDateRange(
                dailyChartType,
                fromDate,
                toDate
            )
                .then(
                    data => commit('getAllSuccess', data),
                    error => commit('getAllFailure', error)
                );
        },
    },
    mutations: {
        getAllRequest(state) {
            state.all = []
            state.loading = true;
        },
        getAllSuccess(state, response) {
            state.all = response.data.results;
            state.loading = false;
        },
        getAllFailure(state) {
            state.loading = false;
        },
    }
}
